/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Scale_TitleInputs */

const tr_katalog_desi_page_scale_title = /** @type {(inputs: Katalog_Desi_Page_Scale_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desi ölçeği`)
};

const en_katalog_desi_page_scale_title = /** @type {(inputs: Katalog_Desi_Page_Scale_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desi scale`)
};

const de_katalog_desi_page_scale_title = /** @type {(inputs: Katalog_Desi_Page_Scale_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desi-Skala`)
};

const ru_katalog_desi_page_scale_title = /** @type {(inputs: Katalog_Desi_Page_Scale_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шкала деси`)
};

/**
* | output |
* | --- |
* | "Desi scale" |
*
* @param {Katalog_Desi_Page_Scale_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_scale_title = /** @type {((inputs?: Katalog_Desi_Page_Scale_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Scale_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_scale_title(inputs)
	if (locale === "de") return de_katalog_desi_page_scale_title(inputs)
	if (locale === "ru") return ru_katalog_desi_page_scale_title(inputs)
	return tr_katalog_desi_page_scale_title(inputs)
});